'use client';
import React, { useState } from 'react';
import styles from './scss/segmentation.module.scss';
import Orchestrate1 from './orchestrate1';
import Orchestrate2 from './orchestrate2';
import Orchestrate3 from './orchestrate3';
import Orchestrate4 from './orchestrate4';

const OrchestrationTs = ({ onComplete }: { onComplete?: () => void }) => {
  const [seg1Done, setSeg1Done] = useState(false);
  const [seg2Done, setSeg2Done] = useState(false);
  const [seg3Done, setSeg3Done] = useState(false);

  return (
    <div className={`${styles.segmentationsec} ${styles.obstr}`}>
      <div className={styles.obstrinnerleft}>
        <Orchestrate1 onComplete={() => setSeg1Done(true)} />
        {seg1Done && <Orchestrate2 onComplete={() => setSeg2Done(true)} />}
        {/* {seg2Done && <Orchestrate3 onComplete={() => setSeg3Done(true)} />} */}
      </div>
      <div className={styles.obstrinnerright}>
          {seg2Done && <Orchestrate4 onComplete={onComplete} />}
      </div>
    </div>
  );
};

export default OrchestrationTs;